// Port de app/meus-dados-prestador.tsx.
import { Carregando } from "@/app/Carregando";
import { lazy } from "react";

const MeusDadosPrestadorScreen = lazy(() => import("@/screens/MeusDadosPrestador"));

export default function MeusDadosPrestadorRoute() {
  return (
    <Carregando cor="#f2f7f9">
      <MeusDadosPrestadorScreen />
    </Carregando>
  );
}
